import { render, staticRenderFns } from "./Diethistorypopup.vue?vue&type=template&id=436abdd7&scoped=true&"
import script from "./Diethistorypopup.vue?vue&type=script&lang=js&"
export * from "./Diethistorypopup.vue?vue&type=script&lang=js&"
import style0 from "./Diethistorypopup.vue?vue&type=style&index=0&id=436abdd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436abdd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436abdd7')) {
      api.createRecord('436abdd7', component.options)
    } else {
      api.reload('436abdd7', component.options)
    }
    module.hot.accept("./Diethistorypopup.vue?vue&type=template&id=436abdd7&scoped=true&", function () {
      api.rerender('436abdd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DietaryNutrition/Diethistorypopup.vue"
export default component.exports